/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iade_Iptal_S11_P2Inputs */

const tr_iade_iptal_s11_p2 = /** @type {(inputs: Iade_Iptal_S11_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Silme taleplerinizi de kvkk@emonse.com adresine iletebilirsiniz; talep KVKK hakları ve yasal saklama yükümlülükleri çerçevesinde değerlendirilir.`)
};

const en_iade_iptal_s11_p2 = /** @type {(inputs: Iade_Iptal_S11_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You can also send deletion requests to kvkk@emonse.com; requests are assessed under KVKK rights and statutory retention duties.`)
};

const de_iade_iptal_s11_p2 = /** @type {(inputs: Iade_Iptal_S11_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auch Löschanfragen können Sie an kvkk@emonse.com senden; sie werden nach den KVKK-Rechten und gesetzlichen Aufbewahrungspflichten geprüft.`)
};

const ru_iade_iptal_s11_p2 = /** @type {(inputs: Iade_Iptal_S11_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Запросы на удаление также можно направить на kvkk@emonse.com; они рассматриваются с учётом прав по KVKK и законных обязанностей хранения.`)
};

/**
* | output |
* | --- |
* | "You can also send deletion requests to kvkk@emonse.com; requests are assessed under KVKK rights and statutory retention duties." |
*
* @param {Iade_Iptal_S11_P2Inputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const iade_iptal_s11_p2 = /** @type {((inputs?: Iade_Iptal_S11_P2Inputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iade_Iptal_S11_P2Inputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_iade_iptal_s11_p2(inputs)
	if (locale === "de") return de_iade_iptal_s11_p2(inputs)
	if (locale === "ru") return ru_iade_iptal_s11_p2(inputs)
	return tr_iade_iptal_s11_p2(inputs)
});